import React from 'react';

import { useIntl } from 'react-intl';

import { tableMessages as messages } from '@atlaskit/editor-common/messages';
import { TableCellSplitIcon, ToolbarDropdownItem } from '@atlaskit/editor-toolbar';

export const SplitCellItem = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<ToolbarDropdownItem elemBefore={<TableCellSplitIcon label="" size="small" />}>
			{formatMessage(messages.splitCell)}
		</ToolbarDropdownItem>
	);
};
